<template>
<div class="chapter">
<div class="inner_page">
<div id="ht">
<br/><br/><br/><br/><br/><br/>
<p class="Body ParaOverride-3" style="font-size: 1.7em;"><span class="CharOverride-3">Dinky Donkey Doo</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02-ht.vue?26bf153a